import { Box, Text } from '@factorialco/deprecated-design-system'
import { LedgerAccountFragment } from 'generated/resources/graphql'

import { LedgerAccountSelector } from 'modules/banking/components/LedgerAccountSelector'

interface Props {
  label: string
  description: string
  legalEntityId: string
  selectedLedgerAccountId?: string
  accounts?: LedgerAccountFragment[]
  disabled: boolean
  onSelect: (id: string) => void
}
export const DefaultConfigurationRow = ({
  label,
  description,
  legalEntityId,
  selectedLedgerAccountId,
  accounts,
  disabled,
  onSelect,
}: Props) => {
  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" gap="s16">
      <Box width="s600">
        <Text size={'400'} weight="semibold">
          {label}
        </Text>
        <Text size={'200'} weight="normal">
          {description}
        </Text>
      </Box>
      <Box width="full">
        <LedgerAccountSelector
          legalEntityId={legalEntityId}
          selectedLedgerAccountIdProp={selectedLedgerAccountId}
          accounts={accounts}
          canManage
          disabled={disabled}
          onSelect={onSelect}
        />
      </Box>
    </Box>
  )
}
